import { render, staticRenderFns } from "./NotificationTable.global.vue?vue&type=template&id=20c94bc4&scoped=true&lang=pug&"
import script from "./NotificationTable.global.vue?vue&type=script&lang=ts&"
export * from "./NotificationTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTable.global.vue?vue&type=style&index=0&id=20c94bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c94bc4",
  null
  
)

export default component.exports